<article class="customer-details-container">
  <section class="side-menu">
    <app-customer-side-menu></app-customer-side-menu>
  </section>
  <section class="wrapper">
    <router-outlet></router-outlet>
  </section>
</article>
